module.exports = __webpack_public_path__ + "static/media/django.da233e2d.svg";